import { RiErrorWarningFill } from "react-icons/ri";
import { IoMdInformationCircle } from "react-icons/io";
import styles from "./styles.module.css";

const MESSAGE_STATES = {
  ERROR: "error",
  INFO: "info",
};

const MessageBox = ({
  label,
  icon,
  state = MESSAGE_STATES.INFO,
  containerClassName,
  iconClassName,
  labelClassName,
}) => {
  const getIcon = () => {
    if (icon) return icon;
    switch (state) {
      case MESSAGE_STATES.ERROR:
        return (
          <RiErrorWarningFill
            className={`${styles["icon-error"]} ${iconClassName || ""}`}
          />
        );
      case MESSAGE_STATES.INFO:
      default:
        return (
          <IoMdInformationCircle
            className={`${styles["icon-info"]} ${iconClassName || ""}`}
          />
        );
    }
  };

  const containerClasses = [
    styles["message-box-container"],
    state === MESSAGE_STATES.ERROR ? styles["error"] : "",
    containerClassName || "",
  ]
    .join(" ")
    .trim();

  return (
    <div className={containerClasses}>
      {getIcon()}
      <p className={`${styles["label"]} ${labelClassName || ""}`}>{label}</p>
    </div>
  );
};

export default MessageBox;

import PropTypes from "prop-types";

MessageBox.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  state: PropTypes.oneOf(Object.values(MESSAGE_STATES)),
  containerClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};
